import {
    merge
} from './../../../../tool/util';
export default class AbstractOverlay {
    constructor(baseConfig, opts) {
        this.options = merge(baseConfig, opts || {});
        this.data = [];
    }
    /**
     *设置数据
     *
     * @param {*} [geoJsonPoints=[]]
     * @memberof AbstractOverlay
     */
    setValue(geoJsonPoints = []) {
        this.data = JSON.parse(JSON.stringify(geoJsonPoints));
    }
    _geoPointToEchart(geoJsonPoint) {
        return {
            name: geoJsonPoint.name,
            value: geoJsonPoint.geometry.coordinates.concat(geoJsonPoint.count) || 0
        };
    }
    /**
     *获得配置样式
     * @param {*} item
     * @returns
     * @memberof AbstractOverlay
     */
    _getSplitListStyle(item) {
        let splitList = this.options.splitList,
            len = splitList.length,
            count = parseFloat(item.count);
        let style = { ...this.options
        };
        delete style.splitList;
        let result = merge({}, style);

        for (let i = 0; i < len; i++) {
            let condition = splitList[i];
            if (i == splitList.length - 1) {
                if (condition.end == null) {
                    if (count >= condition.start) {
                        result = merge(result, condition);
                        break;
                    }
                } else if (count >= condition.start && count <= condition.end) {
                    result = merge(result, condition);
                    break;
                }
            } else {
                if (count >= condition.start && count < condition.end) {
                    result = merge(result, condition);
                    break;
                }
            }
        }
        return result;
    }
    toString(){
        /**  抽象方法子类实现  */
    }

}